import { motion } from "framer-motion";
import { Gauge, Copy, Droplets, Filter } from "lucide-react";
import { Reveal } from "./Reveal";
import { useT } from "@/lib/i18n";

const ICONS = [Gauge, Copy, Droplets, Filter];
const TAGS = [["Stage 1", "Stage 2"], ["ECU", "TCU"], ["SCR"], ["DPF", "EGR"]];
const TXT = {
  no: [
    ["Motoroptimalisering", "Stage 1 og Stage 2 programvare for mer effekt, bedre respons og jevnere kjøring.", ["Girkasse"]],
    ["Kloning av komponenter", "Vi kloner styreenheter og moduler ved bytte eller feil – data overføres fra gammel til ny enhet.", ["Instrument", "Moduler"]],
    ["AdBlue", "Feilsøking og hjelp med AdBlue/SCR-systemet ved feilmeldinger og varsler.", ["Feilkoder"]],
    ["DPF / EGR", "Hjelp med partikkelfilter og EGR-ventil: diagnose, regenerering og løsninger.", ["Regenerering"]],
  ],
  en: [
    ["Engine optimisation", "Stage 1 and Stage 2 software for more power, better response and smoother driving.", ["Gearbox"]],
    ["Component cloning", "We clone control units and modules after replacement or failure – data is transferred from the old unit to the new one.", ["Cluster", "Modules"]],
    ["AdBlue", "Troubleshooting and help with the AdBlue/SCR system when warnings and fault messages appear.", ["Fault codes"]],
    ["DPF / EGR", "Help with the particulate filter and EGR valve: diagnostics, regeneration and solutions.", ["Regeneration"]],
  ],
};

export const TuningServices = () => {
  const ITEMS = useT(TXT).map(([t, d, extra], i) => ({ icon: ICONS[i], t, d, tags: [...TAGS[i], ...extra] }));
  return (
  <div className="relative mx-auto max-w-7xl px-5 pb-24 sm:px-8 md:pb-32">
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {ITEMS.map((it, i) => (
        <Reveal key={i} delay={i * 0.06}>
          <motion.article whileHover={{ y: -4 }} transition={{ type: "spring", stiffness: 300, damping: 24 }}
            data-testid={`tuning-service-${i}`}
            className="group flex h-full flex-col border border-white/10 bg-[#08090b]/80 p-6 backdrop-blur-xl transition-colors duration-300 hover:border-[var(--red)]/50">
            <div className="mb-6 flex items-center justify-between">
              <it.icon className="text-[var(--red)]" size={24} />
              <span className="font-mono text-xs text-zinc-500">/0{i + 1}</span>
            </div>
            <h3 className="font-display text-2xl font-black uppercase leading-none [overflow-wrap:anywhere] md:text-3xl lg:text-[1.65rem]">{it.t}</h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-300">{it.d}</p>
            <div className="mt-auto flex flex-wrap gap-2 pt-6">
              {it.tags.map((t) => (
                <span key={t} className="border border-white/10 px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider text-zinc-300">{t}</span>
              ))}
            </div>
          </motion.article>
        </Reveal>
      ))}
    </div>
  </div>
  );
};
